import { Outlet, Navigate } from "react-router-dom";
import { Suspense } from "react";

import AuthLayout from "@/components/layout/auth";
import { useAuthData } from "@/store/hooks";
import SplashLoader from "@/components/ui/splashLoader";

const ProtectedRoute: React.FC = () => {
  const { isAuthorized } = useAuthData();

  return isAuthorized ? (
    <Suspense fallback={<SplashLoader />}>
      <Outlet />
    </Suspense>
  ) : (
    <AuthLayout>
      <Navigate to={"/"} />
    </AuthLayout>
  );
};

export default ProtectedRoute;
